import { jwtDecode } from 'jwt-decode';

/** Browser continuity namespace; the server derives its own authenticated actor. */
export const authAccountFromToken = (token: string | null | undefined): string | null => {
  if (!token) return null;
  try {
    const claims = jwtDecode<Record<string, unknown>>(token);
    const claim = (name: string) => typeof claims[name] === 'string' ? (claims[name] as string).trim() : '';
    const issuer = claim('iss');
    const tenant = claim('tid');
    const oid = claim('oid');
    if (oid && (issuer || tenant)) return encodeURIComponent(JSON.stringify(['oid', issuer, tenant, oid]));
    const subject = claim('sub');
    return issuer && subject ? encodeURIComponent(JSON.stringify(['sub', issuer, subject])) : null;
  } catch {
    return null;
  }
};

export const getCurrentAuthAccount = () => {
  try {
    return authAccountFromToken(localStorage.getItem('token'));
  } catch {
    return null;
  }
};

export class AuthAccountChangedError extends Error {
  constructor() {
    super('Your signed-in account changed. Sign in to the original account to recover this copy.');
    this.name = 'AuthAccountChangedError';
  }
}

export const assertAuthAccount = (expected: string, token?: string | null) => {
  if (!expected || getCurrentAuthAccount() !== expected || (token !== undefined && authAccountFromToken(token) !== expected)) {
    throw new AuthAccountChangedError();
  }
};
